//#region src/assets/mail-error.png
var mail_error_default = "" + new URL("mail-error-DAt-ATEa.png", import.meta.url).href;
//#endregion
export { mail_error_default as default };

//# sourceMappingURL=mail-error.js.map